const React = globalThis.React;
import { CheckIcon } from '../Icons.jsx';

export function FeatureList({ features = [] }) {
  if (!features || !Array.isArray(features) || features.length === 0) {
    return null;
  }

  return (
    <ul className="space-y-2">
      {features.map((f, index) => {
        // Sicherstellen, dass f ein String ist
        if (typeof f !== 'string' || !f) {
          return null;
        }

        if (f.startsWith("GROW Vorteil") || f === "GROW Vorteil") {
          return (
            <li key={`grow-${index}`} className="flex items-center gap-2">
              <CheckIcon />
              <span className="flex flex-col leading-tight text-sky-50">
                <span className="text-xs font-medium">Grow Vorteil</span>
                <span className="text-sm font-semibold">Jedes Jahr 5 GB mehr</span>
              </span>
            </li>
          );
        }

        if (f.startsWith("Kombi-Vorteil")) {
          return null;
        }

        if (typeof f === "string" && f.includes("ChatGPT")) {
          return (
            <li key={`chatgpt-${index}`} className="flex items-center gap-2">
              <span className="w-4 h-4 bg-emerald-500 text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">+</span>
              <span className="text-sm text-sky-50 font-medium">
                6 Monate ChatGPT Plus gratis
              </span>
            </li>
          );
        }

        if (f.startsWith("Doppeltes Datenvolumen")) {
          return (
            <li key={`doppelt-${index}`} className="flex items-center gap-2">
              <CheckIcon />
              <span className="text-sm font-semibold text-sky-50">Doppeltes Datenvolumen</span>
            </li>
          );
        }

        if (f.includes("Allnet-Flat")) {
          return (
            <li key={`allnet-${index}`} className="flex items-center gap-2">
              <CheckIcon />
              <span className="text-sm font-semibold text-sky-50">Allnet-Flat Telefon & SMS</span>
            </li>
          );
        }

        return (
          <li key={`${f}-${index}`} className="flex items-center gap-2">
            <CheckIcon />
            <span className="text-sm font-medium text-sky-50">{f}</span>
          </li>
        );
      })}
    </ul>
  );
}
